import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { attachmentPropType } from '../../prop-types';
import { AttachmentRow } from './attachment-row';
import { Box } from '../grid';
import { Button } from '../button';
import { H2, P } from '../type';

const AttachmentsList = ({ attachments, handleAttachmentDownload, showCommentsPanel }) => (
  <>
    {!isEmpty(attachments) ? (
      attachments.map((attachment) => (
        <AttachmentRow
          key={attachment.documentID}
          attachment={attachment}
          handleAttachmentDownload={handleAttachmentDownload}
        />
      ))
    ) : (
      <Box flexDirection="column" justifyContent="center" margin="0 auto" maxWidth="50%" textAlign="center">
        {/* @TODO: Fix responsive image srcSet not being picked up */}
        {/* <img
          sizes="100vw"
          srcSet={`${NoMessagesImage} 273px, ${NoMessagesImage2x} 544px, ${NoMessagesImage3x} 817px`}
          src={NoMessagesImage}
          alt="no comments"
        /> */}
        <Box my="md">
          <NoAttachmentsSvg />
        </Box>
        <H2>No Attachments</H2>
        <P>
          All attachments related to this case will show up here. Please add any supporting attachments via a message.
        </P>
        <StyledButton type="button" onClick={showCommentsPanel} variant="primaryTextButton">
          Back to Comments
        </StyledButton>
      </Box>
    )}
  </>
);

const NoAttachmentsSvg = () => (
  <svg width="129" height="128" viewBox="0 0 129 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="128" height="128" rx="64" fill="#F4F5F6" />
    <path
      d="M81.2151 65.1194L64.7351 81.6261C62.5746 83.5461 59.7621 84.5682 56.873 84.4831C53.9839 84.3981 51.2364 83.2124 49.1926 81.1686C47.1488 79.1248 45.9631 76.3773 45.878 73.4882C45.793 70.599 46.815 67.7866 48.7351 65.6261L70.0684 44.2928C71.3421 43.0829 73.0317 42.4083 74.7884 42.4083C76.5451 42.4083 78.2347 43.0829 79.5084 44.2928C80.7493 45.5503 81.4451 47.246 81.4451 49.0128C81.4451 50.7795 80.7493 52.4752 79.5084 53.7328L61.1084 72.1061C60.9263 72.3022 60.7074 72.4605 60.4641 72.572C60.2208 72.6835 59.9579 72.746 59.6905 72.7559C59.4231 72.7658 59.1563 72.7229 58.9054 72.6297C58.6546 72.5366 58.4245 72.3949 58.2284 72.2128C58.0323 72.0307 57.874 71.8117 57.7625 71.5684C57.651 71.3251 57.5885 71.0623 57.5786 70.7949C57.5687 70.5274 57.6116 70.2607 57.7047 70.0098C57.7979 69.7589 57.9396 69.5289 58.1217 69.3328L71.8017 55.6794C72.3039 55.1773 72.586 54.4962 72.586 53.7861C72.586 53.076 72.3039 52.3949 71.8017 51.8928C71.2996 51.3906 70.6185 51.1085 69.9084 51.1085C69.1983 51.1085 68.5172 51.3906 68.0151 51.8928L54.3351 65.5994C53.6505 66.2786 53.1072 67.0866 52.7365 67.9768C52.3657 68.867 52.1748 69.8218 52.1748 70.7861C52.1748 71.7504 52.3657 72.7052 52.7365 73.5954C53.1072 74.4856 53.6505 75.2936 54.3351 75.9728C55.7334 77.3047 57.5905 78.0477 59.5217 78.0477C61.4529 78.0477 63.3101 77.3047 64.7084 75.9728L83.0817 57.5728C85.2014 55.298 86.3554 52.2892 86.3005 49.1804C86.2457 46.0716 84.9863 43.1054 82.7877 40.9068C80.5891 38.7082 77.6229 37.4488 74.5141 37.394C71.4053 37.3391 68.3965 38.4931 66.1217 40.6128L44.7884 61.9461C41.9116 65.1323 40.3751 69.3057 40.4992 73.5967C40.6232 77.8877 42.3981 81.9654 45.4541 84.9801C48.5101 87.9949 52.6115 89.7142 56.9038 89.7799C61.1961 89.8456 65.3482 88.2526 68.4951 85.3328L85.0017 68.8528C85.2504 68.6041 85.4476 68.309 85.5822 67.9841C85.7167 67.6592 85.786 67.3111 85.786 66.9594C85.786 66.6078 85.7167 66.2596 85.5822 65.9348C85.4476 65.6099 85.2504 65.3147 85.0017 65.0661C84.7531 64.8175 84.4579 64.6202 84.1331 64.4857C83.8082 64.3511 83.46 64.2819 83.1084 64.2819C82.7568 64.2819 82.4086 64.3511 82.0837 64.4857C81.7589 64.6202 81.4637 64.8175 81.2151 65.0661V65.1194Z"
      fill="#49525D"
    />
  </svg>
);

const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.interactionSeven};
  font-size: ${({ theme }) => theme.fontSize.base};
  font-weight: ${({ theme }) => theme.fontWeight.normal};

  &:hover:not([disabled]) {
    background-color: transparent;
    border-color: transparent;
  }
`;

AttachmentsList.propTypes = {
  attachments: PropTypes.arrayOf(attachmentPropType).isRequired,
  handleAttachmentDownload: PropTypes.func.isRequired,
  showCommentsPanel: PropTypes.func.isRequired,
};

export { AttachmentsList };
